<div class="cm__page-not-found" style="display: block">
  <div class="cm__container is-4060 is-adjacent">
    <div class="cm__container__col">
      <div class="cm__rte internal-server-error">
        <h1 class="header header--1">Sorry, there is a problem with our servers.</h1>
        <p>Rest assured our developers are working hard to repair it, please come back soon</p>
        <div
          role="button"
          tabindex="0"
          aria-label="Retry Trustage Annuities"
          class="retry-trustsge"
          [routerLink]="['/advisor']"
        >
          <svg width="32" height="12" viewBox="0 0 32 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              _ngcontent-ng-c1919520737=""
              d="M26.2603 1.67969L30.5803 5.99916L26.2603 10.3197"
              stroke="#193062"
              stroke-width="2"
              stroke-linecap="round"
            ></path>
            <rect
              _ngcontent-ng-c1919520737=""
              x="0.339844"
              y="4.91895"
              width="31.32"
              height="2.16"
              rx="1"
              fill="#193062"
            ></rect>
          </svg>
          <div class="btn-view">
            <div class="btn-view-txt">Retry TruStage Annuities</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cm__container__col">
      <div class="cm__rte">
        <img alt="" src="/assets/images/500-hero-mvf2.jpeg" class="initial loading" data-was-processed="true" />
      </div>
    </div>
  </div>
</div>
